/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { useResponsive } from '../../hooks';
import { useThemeMode } from '../../providers/ThemeModeProvider';
import { HEADER_HEIGHT_DESKTOP, HEADER_HEIGHT_MOBILE } from '../Header/headerConstants';

export interface HeaderLogoProps {
  darkLogo: string;
  lightLogo: string;
  onClick: VoidFunction;
}

export const HeaderLogo = ({ darkLogo, lightLogo, onClick }: HeaderLogoProps) => {
  const { themeMode } = useThemeMode();
  const logo = themeMode === 'light' ? darkLogo : lightLogo;
  const isDesktop = useResponsive('up', 'sm');

  return (
    <img
      alt="logo"
      data-testid="logo-icon"
      onClick={onClick}
      style={{
        height: '100%',
        maxHeight: isDesktop ? HEADER_HEIGHT_DESKTOP : HEADER_HEIGHT_MOBILE,
        cursor: 'pointer',
        maxWidth: 200,
      }}
      src={logo}
    />
  );
};
